import moment from 'moment';
import {
  http,
  delayIt,
} from '../utils/http';
import axios from "axios";
const CancelToken = axios.CancelToken;

export function moneyToNumValue(val) {
  if (typeof val === 'number') {
    return val;
  } else {
    var num = val.trim();
    var ss = num.toString();
    if (ss.length == 0) {
      return '0';
    }
    return ss.replace(/,/g, '');
  }
}

export function numToMoneyStr(num) {
  const number = (Number(num).toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
  return number;
}


export function UpdateData(data) {
  if (data.find(item => item.key === 'footer')) {
    data.pop();
  }
  let footerObj = {
    key: 'footer',
    major_budget_category_name: '合计',
    detail: [],
    total: 0,
    diffMoneyTotal: 0, //用于统计所有调整值之和
  };
  data.forEach((parent, index) => {
    parent.level = 1;
    parent.key = `level1${index}`;
    parent.total = 0;
    parent.diffMoneyTotal = 0; //用于统计当前大类下所有科目调整值之和
    parent.index = index;
    parent.children.forEach((child, child_index) => {
      child.level = 2;
      child.parentIndex = index;
      child.selfIndex = child_index;
      child.key = `level1${index}level2${child_index}`;
      child.diffMoneyTotal = 0; //用于统计当前科目各月份调整值之和
      let totalPriceOfSubject = 0; //用于统计当前科目的年度总预算
      child.detail.forEach((item, item_index) => {
        let month = moment(item.month).month();
        if (!item.changed_money && !item.initFinished) {
          item.changed_money = item.total_money;
          item.initFinished = true
        }
        item.total_money = item.total_money ? moneyToNumValue(item.total_money) : '';
        item.changed_money = item.changed_money ? moneyToNumValue(item.changed_money) : '';
        item.frozen_money = item.frozen_money ? moneyToNumValue(item.frozen_money) : '';
        item.diffMoney = item.changed_money ? (Number(item.changed_money) - Number(item.total_money)) : (0 - Number(item.total_money));
        child.diffMoneyTotal = child.diffMoneyTotal + Number(item.diffMoney); //当前科目各月份调整值之和
        child.diffMoneyTotalStr = numToMoneyStr(child.diffMoneyTotal);
        child[`month${month + 1}`] = {
          diffMoney: numToMoneyStr(item.diffMoney),
          changed_money: item.changed_money,
          frozen_money: item.frozen_money ? numToMoneyStr(item.frozen_money) : undefined,
        };
        totalPriceOfSubject = item.changed_money ? totalPriceOfSubject + Number(item.changed_money) : totalPriceOfSubject;
        if (index === 0 && child_index === 0) {
          let obj = {
            month: item.month,
            total_money: item.total_money,
            changed_money: item.changed_money ? item.changed_money : 0,
            diffMoney: item.diffMoney,
            frozen_money: item.frozen_money ? item.frozen_money : undefined,
          };
          footerObj[`month${month + 1}`] = {
            total_money: numToMoneyStr(item.total_money),
            changed_money: item.changed_money ? numToMoneyStr(item.changed_money) : 0,
            diffMoney: numToMoneyStr(item.diffMoney),
            frozen_money: item.frozen_money ? numToMoneyStr(item.frozen_money) : undefined,
          };
          footerObj.detail.push(obj);
        } else {
          footerObj.detail[item_index].total_money =
            Number(footerObj.detail[item_index].total_money) + Number(item.total_money);
          footerObj.detail[item_index].changed_money = item.changed_money ?
            Number(footerObj.detail[item_index].changed_money) + Number(item.changed_money) : Number(footerObj.detail[item_index].changed_money);
          footerObj.detail[item_index].diffMoney =
            Number(footerObj.detail[item_index].diffMoney) + Number(item.diffMoney);
          footerObj.detail[item_index].frozen_money = item.frozen_money ?
            Number(footerObj.detail[item_index].frozen_money) + Number(item.frozen_money) : Number(footerObj.detail[item_index].frozen_money);
          footerObj[`month${month + 1}`] = {
            changed_money: numToMoneyStr(footerObj.detail[item_index].changed_money),
            diffMoney: numToMoneyStr(footerObj.detail[item_index].diffMoney),
            frozen_money: numToMoneyStr(footerObj.detail[item_index].frozen_money),
          };
        }
        footerObj.total = item.changed_money ? Number(footerObj.total) + Number(item.changed_money) : Number(footerObj.total) //年度预算总和
        footerObj.totalStr = numToMoneyStr(footerObj.total);
        footerObj.diffMoneyTotal =
          Number(footerObj.diffMoneyTotal) + Number(item.diffMoney); // 年度总调整值之和
        footerObj.diffMoneyTotalStr = numToMoneyStr(footerObj.diffMoneyTotal)
      });
      child.total = totalPriceOfSubject; //当前科目年度预算总和
      child.totalStr = numToMoneyStr(totalPriceOfSubject);
      parent.total = Number(parent.total) + Number(child.total); //当前预算大类年度预算总和
      parent.totalStr = numToMoneyStr(parent.total);
      parent.diffMoneyTotal = Number(parent.diffMoneyTotal) + Number(child.diffMoneyTotal);
      parent.diffMoneyTotalStr = numToMoneyStr(parent.diffMoneyTotal);
    });
  });
  data.push(footerObj);
}

export function getBudgetChangeDetailInfo(data) {
  let dataSource = _.cloneDeep(data);
  let changeDetail = [];
  dataSource.forEach(parent => {
    if (parent.children) {
      parent.children.forEach(child => {
        if (child.budget_subject_id || child.isAdd) {
          child.detail.forEach(item => {
            const conDataIndex = `month${moment(item.month)
              .month() + 1}`
            item.total_money = Number(item.total_money).toFixed(2) + '';
            item.changed_money = Number(child[conDataIndex].changed_money).toFixed(2) + '';
            if (!item.team_budget_detail_id) {
              item.team_budget_detail_id = 0;
            }
            if (item.diffMoney || item.diffMoney === 0) delete item.diffMoney
          })
          changeDetail.push({
            budget_subject_id: child.budget_subject_id ? child.budget_subject_id : 0,
            budget_subject_name: child.budget_subject_name,
            major_budget_category_id: parent.major_budget_category_id,
            detail: child.detail,
          })
        }
      })
    }
  })
  return changeDetail;
}

let columns = [{
    title: '预算大类',
    dataIndex: 'major_budget_category_name',
    key: 'major_budget_category_name',
    width: 150,
    fixed: 'left',
  },
  {
    title: '预算科目',
    dataIndex: 'budget_subject_name',
    key: 'budget_subject_name',
    width: 150,
    fixed: 'left',
    scopedSlots: {
      customRender: 'budgetSubjectName'
    },
  },
  {
    title: '年度总预算',
    dataIndex: 'total',
    key: 'total',
    width: 130,
    fixed: 'right',
    scopedSlots: {
      customRender: 'total'
    },
  },
  {
    title: '操作',
    dataIndex: 'edit',
    key: 'edit',
    width: 100,
    fixed: 'right',
    scopedSlots: {
      customRender: 'edit'
    },
  },
];
for (let i = 11; i >= 0; i--) {
  let info = {
    title: moment()
      .month(i)
      .format('YYYY-MM'),
    dataIndex: `month${i + 1}`,
    key: `month${i + 1}`,
    width: 120,
    scopedSlots: {
      customRender: `month${i + 1}`
    },
  };
  columns.splice(2, 0, info);
}

export const COLUMNS = columns;

// 获取预算调整表单布局
export function getBudgetChangeLayout(params) {
  return http.get('/api/fas/budget-change/form', {
    params
  })
}

// 获取新建预算调整默认参数
export function getBudgetChangeDefaultParams(params) {
  return http.get('/api/fas/budget-change/info', {
    params
  })
}

// 获取预算调整详情页参数
export function getBudgetChangeDetailParams(params) {
  return http.get('/api/fas/budget-change/detail', {
    params
  })
}

// 创建预算审批流
export function getBudgetApprovalFlow(params, config) {
  return http.post('/api/fas/budget-change/flow', params, {
    cancelToken: new CancelToken(function executor(c) {
      config.cancelSource = c;
    })
  });
}

// 预算申请详情审批流
export function getBudgetDetailApprovalFlow(params) {
  return http.post('/api/fas/budget-change/flow-history', params);
}

// 提交预算调整申请
export function createBudgetApplication(params) {
  return http.post('/api/fas/budget-change', params);
}

// 获取预算科目下拉框
export function getSubjectOptions(params) {
  return http.get('/api/fas/budget-change/subject-options', {
    params
  });
}

//撤回
export function retreatApplicationProgress(params) {
  return http.post('/api/fas/budget-change/withdraw',
    params
  );
}

export const passApplicationApi = '/api/fas/budget-change/pass';
export const rejectApplicationApi = '/api/fas/budget-change/reject';

//审批通过
export function approvalApplication(url, params) {
  return http.post(url, params);
}

//预算调整团队下拉选接口
export function getBudgetTeams(params) {
  return http.get('/api/fas/budget-change/group-options', {
    params
  });
}